import React, { useState, useEffect } from "react";
import CrmInputField from "../../../component/CrmUI/CrmProfileUI/CrmInputFields";
import CrmSelectField from "../../../component/CrmUI/CrmProfileUI/CrmSelectField";
import { useNavigate, useLocation } from "react-router-dom";
import { useSnackbar } from "../../../context/SnackBarContext";
import fetcher from "../../../helper/fetcher";
import axios from "axios";
import { apiUrl, getAuthToken } from "../../../utils/utils";

const CrmEditProductDetails = () => {
    const location = useLocation()
    const product = location.state
    console.log("asjdjksa ===>>>", product)

    const [formData, setFormData] = useState({
        productName: "",
        productCode: "",
        hsnORsacCode: "",
        productUnit: "",
        availableStock: "",
        mrp: "",
        salePrice: "",
        discountPercentage: "",
        purchasePrice: "",
        gstRate: "",
    });

    useEffect(() => {
        if (product) {
            setFormData({
                productName: product.productName || "",
                productCode: product.productCode || "",
                hsnORsacCode: product.hsnORsacCode || "",
                productUnit: product.productUnit || "",
                availableStock: product.availableStock || "",
                mrp: product.mrp || "",
                salePrice: product.salePrice || "",
                discountPercentage: product.discountPercentage || "",
                purchasePrice: product.purchasePrice || "",
                gstRate: product.gstRate || "",
            });
        }
    }, [product]);

    const [isLoading, setIsLoading] = useState(false);
    const { showSuccess, showError } = useSnackbar();
    const navigate = useNavigate()

    const productUnits = ["Pieces", "Kg", "Meter", "Box", "Packet"];
    const gstRates = ["0", "5", "12", "18", "28"];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };


    const validateForm = () => {
        if (!formData.productName.trim()) {
            showError("Product Name is required");
            return false;
        }
        if (!formData.productCode.trim()) {
            showError("Product Code is required");
            return false;
        }
        if (!formData.hsnORsacCode.trim()) {
            showError("HSN/SAC Code is required");
            return false;
        }
        if (!formData.productUnit) {
            showError("Product Unit is required");
            return false;
        }
        if (!formData.availableStock || isNaN(formData.availableStock)) {
            showError("Available Stock must be a number");
            return false;
        }
        if (!formData.salePrice || isNaN(formData.salePrice)) {
            showError("Sale Price must be a number");
            return false;
        }
        if (!formData.gstRate) {
            showError("GST Rate is required");
            return false;
        }

        if (formData.discountPercentage !== undefined && formData.discountPercentage !== null) {
            if (isNaN(formData.discountPercentage)) {
                showError("Discount must be a number");
                return false;
            }
            if (parseInt(formData.discountPercentage) < 0 || parseInt(formData.discountPercentage) > 100) {
                showError("Discount must be between 0 and 100");
                return false;
            }
        }
        return true;
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setIsLoading(true);

        // Create FormData object
        const formDataToSend = new FormData();

        formDataToSend.append("productName", formData.productName);
        // formDataToSend.append("productCode", formData.productCode);
        // formDataToSend.append("hsnORsacCode", formData.hsnORsacCode);
        formDataToSend.append("productUnit", formData.productUnit);
        formDataToSend.append("availableStock", formData.availableStock);
        formDataToSend.append("mrp", formData.mrp);
        formDataToSend.append("salePrice", formData.salePrice);
        formDataToSend.append("discountPercentage", formData.discountPercentage);
        formDataToSend.append("purchasePrice", formData.purchasePrice);
        formDataToSend.append("gstRate", formData.gstRate);

        //  If you have image upload in future:
        if (formData.product_image) {
            formDataToSend.append("product_image", "");
        }

        let getToken = getAuthToken()
        axios.put(
            `${apiUrl}/crm/product/update_product/${product?._id}`,
            formDataToSend,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: getToken, // attach token
                },
            }
        )
            .then(() => {
                showSuccess("Created successfully");
                setFormData({
                    productName: "",
                    productCode: "",
                    hsnORsacCode: "",
                    productUnit: "",
                    availableStock: "",
                    mrp: "",
                    salePrice: "",
                    discountPercentage: "",
                    purchasePrice: "",
                    gstRate: "",
                });
                navigate('/crm/manage-product')

            })
            .catch((error) => {
                showError(error.response?.data?.message || "Some Error Occured");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div className="p-4 sm:p-6">
            <h2 className="font-bold text-[#0a3021] text-[24px] sm:text-[26px] mb-4">
                Edit Product
            </h2>
            <form
                onSubmit={handleSubmit}
                className="bg-white shadow rounded-lg p-4 sm:p-6"
            >
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-4 sm:gap-6">
                    <CrmInputField
                        label="Product Name *"
                        name="productName"
                        value={formData.productName}
                        onChange={handleChange}
                    />

                    <div className="col-span-1">
                        <label className="block text-black font-semibold uppercase mb-1">
                            Product Code / Barcode
                        </label>
                        <div className="relative">
                            <input
                                type="text"
                                name="productCode"
                                value={formData.productCode}
                                onChange={handleChange}
                                className="w-full border p-2 rounded-lg pr-24"
                                placeholder="Enter or generate code"
                            />
                        </div>
                    </div>

                    <CrmInputField
                        label="HSN/SAC Code *"
                        name="hsnORsacCode"
                        value={formData.hsnORsacCode}
                        onChange={handleChange}
                        type="number"
                    />

                    <CrmSelectField
                        label="Assign Product Unit *"
                        name="productUnit"
                        options={productUnits}
                        value={formData.productUnit}
                        onChange={handleChange}
                    />
                    <CrmInputField
                        label="Available Stock *"
                        name="availableStock"
                        value={formData.availableStock}
                        onChange={handleChange}
                        type="number"
                    />

                    <CrmSelectField
                        label="GST Rate *"
                        name="gstRate"
                        options={gstRates}
                        value={formData.gstRate}
                        onChange={handleChange}
                    />

                    <CrmInputField
                        label="Sale Price *"
                        name="salePrice"
                        value={formData.salePrice}
                        onChange={handleChange}
                        type="number"
                    />
                    <CrmInputField
                        label="Discount on Sale Price (%)"
                        name="discountPercentage"
                        value={formData.discountPercentage}
                        onChange={handleChange}
                        type="number"
                    />
                    <CrmInputField
                        label="Purchase Price"
                        name="purchasePrice"
                        value={formData.purchasePrice}
                        onChange={handleChange}
                        type="number"
                    />

                    <hr className="col-span-1 sm:col-span-2 lg:col-span-3 border-t border-gray-300 shadow-sm mt-2" />
                </div>

                <div className="flex flex-col sm:flex-row justify-end space-y-2 sm:space-y-0 sm:space-x-4 mt-6">
                    <button
                        type="button"
                        className="px-6 py-2 rounded-md bg-gray-200 text-gray-700 hover:bg-gray-300"
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="px-6 py-2 rounded-md bg-green-700 text-white hover:bg-green-800"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    );

};

export default CrmEditProductDetails;

